// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"4b38d16c","565":"eeba62c8"}[chunkId] + ".chunk.css";
};